<template>
    <div class="container mx-auto p-4">
      <h1 class="fs-2 font-bold text-center mb-4">Favoritos</h1>
      <a @click="eliminarSeleccionados" class="text-primary d-flex justify-content-end mb-3" style="cursor: pointer;">🗑 Eliminar favoritos seleccionados</a>
      
      <div class="card p-5 shadow-sm">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">(001123) AGROINDUSTRIA</span>
        </div>
        
        <h2 class="fs-4 fw-bold">Motocompresores, grupos electrógenos, tanques en PRFV y de Ho, autoelevadores y más</h2>
        <p class="text-muted">📅 Jueves 13/02/25 ⏰ 14:00</p>

        <div class="list-group">
          <div v-for="item in favoritos" :key="item.id" class="list-group-item d-flex align-items-center">
            <img :src="item.image" alt="Lote" class="me-3" width="50">
            <div class="flex-grow-1">
              <p class="mb-1">{{ item.title }}</p>
              <small class="text-muted">🔹 {{ item.lote }}</small>
            </div>
            <input type="checkbox" v-model="item.selected" class="form-check-input ms-3" style="appearance: auto;">
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <span class="text-muted">Favoritos 1-8 de 24</span>
          <a @click="eliminarSeleccionados" class="text-primary d-flex justify-content-end mb-3" style="cursor: pointer;">🗑 Eliminar favoritos seleccionados</a>
        </div>

        <nav class="mt-3">
          <ul class="pagination justify-content-center">
            <li class="page-item disabled"><a class="page-link" href="#">&laquo;</a></li>
            <li class="page-item active"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">&raquo;</a></li>
          </ul>
        </nav>
      </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const favoritos = ref([
  { id: 1, title: "10.000 aprox. guantes Mediglove, Talle M (sin uso).", lote: "LOTE 2", image: "https://via.placeholder.com/50", selected: false },
  { id: 2, title: "1.500 aprox. mamelucos XL varios, sin uso.", lote: "LOTE 3", image: "https://via.placeholder.com/50", selected: false },
  { id: 3, title: "2000 aprox. mamelucos XL varios, sin uso.", lote: "LOTE 4", image: "https://via.placeholder.com/50", selected: false },
  { id: 4, title: "2000 aprox. mamelucos XL varios, sin uso.", lote: "LOTE 5", image: "https://via.placeholder.com/50", selected: false },
  { id: 5, title: "500 aprox. mamelucos varios, sin uso.", lote: "LOTE 6", image: "https://via.placeholder.com/50", selected: false },
  { id: 6, title: "Filtro de placas en inoxidable (en el estado que se encuentra y exhibe).", lote: "LOTE 7", image: "https://via.placeholder.com/50", selected: false },
  { id: 7, title: "2 Ollas Industriales, 1.500 litros aprox. (en el estado que se encuentra y exhibe).", lote: "LOTE 8", image: "https://via.placeholder.com/50", selected: false },
  { id: 8, title: "Prensa para extrusión, modelo 140, con motor (en el estado que se encuentra y exhibe).", lote: "LOTE 9", image: "https://via.placeholder.com/50", selected: false }
]);

const eliminarSeleccionados = () => {
  favoritos.value = favoritos.value.filter(item => !item.selected);
};
</script>
